import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Markdown from 'react-markdown';
import styled from 'styled-components';
import { colours, layoutSizes, fontSizes, customFonts } from "../../constants/css";
var ItemExpander = styled.div.withConfig({
  displayName: "Accordion__ItemExpander",
  componentId: "sc-104j4xf-0"
})(["font-family:", ";padding:1rem 0.5rem;cursor:pointer;display:flex;align-items:center;border-radius:4px;margin-bottom:0.625rem;background:", ";&:last-child{margin-bottom:0;}@media only screen and (min-width:", "){padding:1rem;}"], function (props) {
  return props.active ? customFonts.ciutadellaMed : customFonts.ciutadellaReg;
}, colours.qantasWhite, layoutSizes.desktopWidth);
var ItemIcon = styled.div.withConfig({
  displayName: "Accordion__ItemIcon",
  componentId: "sc-104j4xf-1"
})(["font-size:", ";margin-right:0.5rem;"], fontSizes.xxl);
var ItemDetail = styled.div.withConfig({
  displayName: "Accordion__ItemDetail",
  componentId: "sc-104j4xf-2"
})(["background:", ";padding:0 2rem 0.625rem;"], colours.qantasIceWhite);
var Accordion = /*#__PURE__*/function (_Component) {
  function Accordion() {
    var _this;
    _classCallCheck(this, Accordion);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, Accordion, [].concat(args)), _this.state = {
      activeItem: null
    }, _this.expand = function (evt, tabId) {
      _this.setState({
        activeItem: _this.state.activeItem === tabId ? null : tabId
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(Accordion, _Component);
  return _createClass(Accordion, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this.setState({
        activeItem: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var activeItem = this.state.activeItem;
      var items = this.props.items;
      if (!items) {
        return null;
      }
      return items.map(function (_ref, key) {
        var id = _ref.id,
          title = _ref.title,
          description = _ref.description;
        var currentItem = activeItem === id;
        return __jsx(React.Fragment, {
          key: key
        }, __jsx(ItemExpander, {
          key: key,
          onClick: function onClick(evt) {
            return _this2.expand(evt, id);
          },
          active: currentItem,
          tabIndex: "0",
          role: "button",
          "aria-pressed": "false",
          onKeyPress: function onKeyPress(evt) {
            return _this2.expand(evt, id);
          }
        }, __jsx(ItemIcon, null, currentItem ? '-' : '+'), __jsx("span", null, title)), currentItem && __jsx(ItemDetail, null, __jsx(Markdown, null, description)));
      });
    }
  }]);
}(Component);
export default Accordion;